/* eslint-disable react/prop-types */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React, {
  Dispatch,
  SetStateAction,
  createContext,
  useContext,
  useMemo,
  useState,
} from "react";

interface CredentialsDTO {
  login: string;
  password: string;
  token: string | null;
}

interface MFADTO {
  credentials: CredentialsDTO;
  setCredentials: Dispatch<SetStateAction<CredentialsDTO>>;
  setAttempts: Dispatch<SetStateAction<number>>;
  attempts: number;
  userId: string | null;
  setUserId: Dispatch<SetStateAction<string | null>>;
}

const MFAContext = createContext<MFADTO>({} as MFADTO);

export const MFAContextProvider = ({ children }) => {
  const [attempts, setAttempts] = useState(1);
  const [credentials, setCredentials] = useState<CredentialsDTO>({
    login: sessionStorage.getItem("@UltragazEmpresarial:X-Mfa-Login") || "",
    password: "",
    token: localStorage.getItem("@UltragazEmpresarial:X-Mfa-Hash")
      ? localStorage.getItem("@UltragazEmpresarial:X-Mfa-Hash")
      : "",
  });
  const [userId, setUserId] = useState(null);

  return (
    <MFAContext.Provider
      value={useMemo(
        () => ({
          credentials,
          setCredentials,
          setAttempts,
          attempts,
          userId,
          setUserId,
        }),
        [credentials, attempts]
      )}
    >
      {children}
    </MFAContext.Provider>
  );
};

export const useMFAContext = () => useContext(MFAContext);
